import { Component } from '@angular/core';
import { GeneralService } from 'src/app/services/general.service';

@Component({
    selector: 'app-accessdenied',
    templateUrl: './accessdenied.component.html',
    styleUrls: ['./accessdenied.component.scss'],
    standalone: false
})
export class AccessdeniedComponent {
	
  constructor(generalService: GeneralService) { }
  
	ngAfterViewInit() {
    window.onbeforeunload = null;
	}

}
